import React, { useMemo } from "react";

function PillItem({ value, selected, onClick, disabled, children }) {
  const fg = selected
    ? "var(--color-text-text-cta-primary, white)"
    : "var(--color-text-text-primary, #1A1A1B)";

  const bg = selected
    ? "var(--color-surface-surface-accent-hover, #1A5869)"
    : "var(--color-surface-surface-secondary, rgba(255, 255, 255, 0.45))";

  const content = React.isValidElement(children)
    ? React.cloneElement(children, {
        style: { ...(children.props?.style || {}), color: "inherit" },
      })
    : (
      <span
        style={{
          color: "inherit",
          fontSize: 12,
          fontFamily: "DM Sans",
          fontWeight: 500,
          wordWrap: "break-word",
          lineHeight: "14px",
        }}
      >
        {children}
      </span>
    );

  return (
    <button
      type="button"
      onClick={() => onClick?.(value)}
      disabled={disabled}
      aria-pressed={selected}
      style={{
        width: 40,
        height: 40,
        borderRadius: 9999,
        border: "none",
        cursor: disabled ? "not-allowed" : "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: bg,
        color: fg,
        boxSizing: "border-box",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {content}
    </button>
  );
}

export default function Pills({
  options,
  value,
  onChange,
  disabled = false,
  gap = 10,
}) {
  const entries = useMemo(() => {
    if (!options) return [];
    if (Array.isArray(options)) return options.map((v) => [String(v), String(v)]);
    return Object.entries(options).map(([k, v]) => [String(k), String(v)]);
  }, [options]);

  return (
    <div
      style={{
        display: "inline-flex",
        gap,
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      {entries.map(([k, label]) => (
        <PillItem
          key={k}
          value={k}
          selected={String(value) === k}
          disabled={disabled}
          onClick={(v) => onChange?.(v)}
        >
          {label}
        </PillItem>
      ))}
    </div>
  );
}
